'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeReducer = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _actions = require('./actions'); // Barebone reducer from type


var defaultDataReducer = function defaultDataReducer(prevState, _ref) {
  var payload = _ref.payload;
  return payload.data;
};

var makeReducer = exports.makeReducer = function makeReducer(type) {
  var dataReducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDataReducer;
  var actionTypes = (0, _actions.makeActionTypes)(type);
  var defaultState = {
    loading: false,
    error: null,
    data: null
  };
  return function () {
    var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var type = action.type;

    switch (type) {
      case actionTypes.loading:
        return _extends({}, prevState, {
          error: null,
          loading: true
        });

      case actionTypes.failure:
        return _extends({}, prevState, {
          loading: false,
          error: action.payload
        });

      case actionTypes.success:
        return _extends({}, prevState, {
          loading: false,
          data: dataReducer(prevState.data, action)
        });

      case actionTypes.unload:
        // So easy if someone add some shit to state
        // simply preserve that keys!
        return _extends({}, prevState, defaultState);

      default:
        return prevState;
    }
  };
};